/** Rozet resmi olan ünvan aileleri (public/unvan-rozet/<aile>/NN.webp). */
export const TITLE_IMAGE_FAMILIES = ["istikrar", "muzakere", "odak", "hatim", "meclis"];

/** Aile ve seviyeden rozet resminin adresi; bilinmeyen aile ya da seviyede null. */
export function titleImageUrl(family, level) {
  const lv = Number(level);
  if (!TITLE_IMAGE_FAMILIES.includes(family)) return null;
  if (!Number.isInteger(lv) || lv < 1 || lv > 10) return null;
  const nn = String(lv).padStart(2, "0");
  return `${process.env.PUBLIC_URL || ""}/unvan-rozet/${family}/${nn}.webp`;
}

/**
 * Ünvan nesnesinden rozet resmi: önce family + level, yoksa "<aile>.<seviye>"
 * kodu çözülür. fallbackFamily, aile bilgisi üstten gelen eski veriler için.
 */
export function titleImageOf(title, fallbackFamily) {
  if (!title) return null;
  let family = title.family || fallbackFamily;
  let level = title.level;
  const match = /^([a-z]+)\.(\d+)$/.exec(String(title.code || ""));
  if (match) {
    if (!title.family) family = match[1];
    if (level == null) level = Number(match[2]);
  }
  return titleImageUrl(family, level);
}

/** Seviye malzemesinin etiket anahtarı (Bronz, Gümüş, Altın). */
export function tierLabelKey(tier) {
  if (tier === "bronz" || tier === "gumus" || tier === "altin") return `titles_tier_${tier}`;
  return null;
}

/**
 * Kişinin profil resmi: sunucudan gelen avatar ({ code, family, level }) ya
 * da yalnız kod ("istikrar.3", ör. user.avatarTitle). Çözülemezse null.
 * Dönen nesnede resim adresi (src) ve ünvan adı (name, yoksa null) da var.
 */
export function avatarOf(person) {
  if (!person) return null;
  const raw = person.avatar || (person.avatarTitle ? { code: person.avatarTitle } : null);
  if (!raw) return null;
  let { family, level } = raw;
  const match = /^([a-z]+)\.(\d+)$/.exec(String(raw.code || ""));
  if (match) {
    if (!family) family = match[1];
    if (level == null) level = Number(match[2]);
  }
  const src = titleImageUrl(family, level);
  if (!src) return null;
  // Ad sunucudan (avatar.name); eski sunucuda yoksa null, altyazı çizilmez.
  const name = raw.name || null;
  return { code: raw.code || `${family}.${level}`, family, level, src, name };
}
